import request from '@/utils/request';

export function statistics() {
  return request({
    url: '/invoice-statistics',
    method: 'get',
  });
}